import { render, staticRenderFns } from "./AccountSettingsScreen.vue?vue&type=template&id=c829c794&"
import script from "./AccountSettingsScreen.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports